/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import GlobalContext from "../../../components/Context/GlobalContext";
import ErrorMessage from "../../../components/ErrorMessage";
import { userService } from "../../../services/user.services";
import { dataService } from "../../../services/data.services";
import Button from "../../../components/Button";
import PassWordValidator from "../../../components/PasswordValidator";
import CardHeader from "../../../components/CardHeader";
import { useDispatch, useSelector } from "react-redux";
import { CognitoData } from "../../../CommonMethods/CognitoData";

export default function UpdatePassword() {
    const [newType, setNewtype] = useState("password");
    const [confirmType, setConfirmtype] = useState("password");
    const [currentType, setCurrentType] = useState("password");
    const [urlPrams, setUrlParams] = useSearchParams();
    const { email } = useSelector(state => state.auth);
    const [errormessage, seterrormessage] = useState('');
    const [submitSelected, setsubmitSelected] = useState(false);
    const [error, seterror] = useState({
        criteriaError: '',
        inputError: '',
        currentPasswordError: '',
        newPasswordError: '',
        confirmPasswordError: ''

    })

    const [loading, setloading] = useState(false)
    const { setToastmessage, setToastErrorMessage, Toastmessage } = useContext(GlobalContext);
    const [password, setpassword] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [errorState, setErrorState] = useState({})
    const { currentPassword, newPassword,
        confirmPassword } = password
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$])[a-zA-Z\d!@#$]{8,}$/;
    const handleClear = () => {
        seterrormessage({
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
        })
    }
    const handleInput = (key, value) => {

        setpassword((prv) => ({
            ...prv,
            [key]: value
        }))
    }


    const isError = (key) => submitSelected && !loading && (!passwordRegex.test(newPassword)) && error;
    const iscompareError = (key) => submitSelected && !loading && (newPassword !== confirmPassword) || (newPassword === '' && confirmPassword === '');
    const checkState = () => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,16}$/.test(newPassword) === false
    const CustomError = (key) => submitSelected && key === ''
    const navigate = useNavigate();
    const handleValidation = () => {
        let newObj = {}
        Object.keys(password).map((val) => {
            if (password[val] === '') {
                newObj[val] = 'This field is mandatory'
            }
        })
        setErrorState(newObj);
        return Object.keys(newObj).length === 0
    }
    const handleSubmit = async (e) => {
        e.preventDefault();

        setloading(true)
        setNewtype('password');
        setConfirmtype('password')
        setsubmitSelected(true);
        if (!handleValidation()) {
            setloading(false);
            return
        }
        if (newPassword !== confirmPassword) {
            setErrorState((prv) => ({
                ...prv,
                'confirmPassword': 'Password do not match'
            }));
            setloading(false);
            return

        }
        if (/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,16}$/.test(newPassword) === false) {
            setloading(false);
            return

        }
        const userData = await CognitoData();

        const payload = {
            "email": userData.idToken.payload.email,
            "current_password": currentPassword,
            "new_password": newPassword,
            "confirm_password": confirmPassword
        }

        try {
            const response = await dataService.PostAPI(payload, 'admin-users/update-password'); 
            if (!response.error) {
                setToastmessage(response.data.message)
                setloading(false);
                navigate('/')

            }
        } catch (error) {
            if (error?.response?.data.message === "Incorrect password") {
                setErrorState((prv) => ({
                    ...prv,
                    'currentPassword': error?.response?.data.message || 'Something went wrong'
                }));
                setloading(false)
                return
            }

            else {
                seterror((prv) => ({
                    ...prv,
                    'inputError': error?.response?.data.message || 'Something went wrong'
                }));
                setloading(false)
                return
            }
            console.log(error)

        }

    }
    return (

        <CardHeader header="Password Update" noIcon>
            <div className=" h-customh7 bg-[#F5F5F5] flex flex-col flex-grow w-full px-4 py-[14px] mt-[110px] overflow-x-hidden">
                <div className="w-[100wh] h-[100vh] flex justify-center items-center bg-white ">
                    <div className="w-fit xs:px-0 sm:px-[130px] text-center bg-white m-4 rounded-[8px]">
                        <h1 className="pt-[38px] text-[#666] font-minionpro text-2xl font-normal">
                            Update Password
                        </h1>
                        <div className="relative pt-[24px]">
                            <div className="flex justify-center">
                                <div className="relative w-full flex justify-center">
                                    <div className="relative w-[100%]">
                                        <input
                                            type={currentType}
                                            className={`${submitSelected && (currentPassword === '' || errorState['currentPassword'] && errorState['currentPassword'] !== '') ? 'input-error' : 'input-border'} peer m-0 block h-[58px] w-[100%] rounded-[4px] border border-solid border-[#ddd] bg-transparent bg-clip-padding px-3 pr-[47px] py-4 text-base font-minionpro font-normal outline-none text-black transition duration-200 ease-linear placeholder-[#1F1F1F] focus:border-[#ddd] focus:pb-[0.625rem] focus:pt-[1.625rem] focus:text-neutral-700 focus:outline-none peer-focus:text-black dark:border-[#ddd] dark:text-black dark:focus:border-black dark:peer-focus:text-black [&:not(:placeholder-shown)]:pb-[0.625rem] [&:not(:placeholder-shown)]:pt-[1.625rem]`}
                                            id="currentPassword"
                                            data-testid='current_password'
                                            onFocus={() => {
                                                setsubmitSelected(false)
                                                setCurrentType("text")
                                            }}
                                            placeholder=""
                                            onChange={(e) => handleInput('currentPassword', e.target.value)}
                                        />
                                        <label
                                            className={`pointer-events-none absolute left-0 top-0 origin-[0_0] border border-solid border-transparent px-3 py-4  ${submitSelected && (currentPassword === '' || errorState['currentPassword'] && errorState['currentPassword'] !== '') ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} font-minionpro transition-[opacity,_transform] duration-200 ease-linear peer-focus:-translate-y-2 peer-focus:translate-x-[0.15rem] peer-focus:scale-[0.85] peer-focus:text-black peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:translate-x-[0.15rem] peer-[:not(:placeholder-shown)]:scale-[0.85] motion-reduce:transition-none dark:text-black dark:peer-focus:text-black`}
                                        >
                                            Current Password
                                        </label>
                                    </div>
                                </div>


                            </div>
                            {submitSelected && !loading && (currentPassword === '' || errorState['currentPassword'] && errorState['currentPassword'] !== '' !== '') && <ErrorMessage error message={errorState['currentPassword']} classKey={'font-normal text-left text-sm text-[#FC4523] mt-[8px]'} />}



                            {currentType === "text" ? (
                                <img
                                    className="absolute top-[41px] right-[16px] cursor-pointer"
                                    src="/assets/images/eye-open.svg"
                                    id="currentPasswordIcon"
                                    alt=""
                                    data-testid="open-eye"
                                    onClick={() => setCurrentType("password")}
                                />
                            ) : (
                                <img
                                    className="absolute top-[41px] right-[16px] cursor-pointer"
                                    src={`/assets/images/${submitSelected && (currentPassword === '' || errorState['currentPassword'] && errorState['currentPassword'] !== '') ? 'eye-error.svg' : 'eye.svg'}`}
                                    id="currentPasswordIcon"
                                    alt=""
                                    data-testid="close-eye"
                                    onClick={() => setCurrentType("text")}
                                />
                            )}
                        </div>
                        <div className="relative pt-[24px]">
                            <div className="flex justify-center">
                                <div className="relative w-full flex justify-center">
                                    <div className="relative w-[100%]">
                                        <input
                                            type={newType}
                                            className={`${submitSelected && (newPassword === '' || errorState['newPassword'] && errorState['newPassword'] !== '') ? 'input-error' : 'input-border'} peer m-0 block h-[58px] w-[100%] rounded-[4px] border border-solid border-[#ddd] bg-transparent bg-clip-padding px-3 pr-[47px] py-4 text-base font-minionpro font-normal outline-none text-black transition duration-200 ease-linear placeholder-[#1F1F1F] focus:border-[#ddd] focus:pb-[0.625rem] focus:pt-[1.625rem] focus:text-neutral-700 focus:outline-none peer-focus:text-black dark:border-[#ddd] dark:text-black dark:focus:border-black dark:peer-focus:text-black [&:not(:placeholder-shown)]:pb-[0.625rem] [&:not(:placeholder-shown)]:pt-[1.625rem]`}
                                            id="newPassword"
                                            data-testid='new_password'
                                            onFocus={() => {
                                                setsubmitSelected(false)
                                                setNewtype("text")
                                            }
                                            }
                                            placeholder=""
                                            onChange={(e) => handleInput('newPassword', e.target.value)}
                                        />
                                        <label
                                            className={`pointer-events-none absolute left-0 top-0 origin-[0_0] border border-solid border-transparent px-3 py-4  ${submitSelected && (newPassword === '' || errorState['newPassword'] && errorState['newPassword'] !== '') ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'} font-minionpro transition-[opacity,_transform] duration-200 ease-linear peer-focus:-translate-y-2 peer-focus:translate-x-[0.15rem] peer-focus:scale-[0.85] peer-focus:text-black peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:translate-x-[0.15rem] peer-[:not(:placeholder-shown)]:scale-[0.85] motion-reduce:transition-none dark:text-black dark:peer-focus:text-black`}
                                        >
                                            New Password
                                        </label>
                                    </div>
                                </div>

                            </div>



                            {newType === "text" ? (
                                <img
                                    className="absolute top-[41px] right-[16px] cursor-pointer"
                                    src="/assets/images/eye-open.svg"
                                    id="newPasswordIcon"
                                    alt=""
                                    data-testid="open-eye"
                                    onClick={() => setNewtype("password")}
                                />
                            ) : (
                                <img
                                    className="absolute top-[41px] right-[16px] cursor-pointer"
                                    src={`/assets/images/${submitSelected && (newPassword === '' || errorState['newPassword'] && errorState['newPassword'] !== '') ? 'eye-error.svg' : 'eye.svg'}`}
                                    id="newPasswordIcon"
                                    alt=""
                                    data-testid="close-eye"
                                    onClick={() => setNewtype("text")}
                                />
                            )}
                        </div>
                        {submitSelected && !loading && (submitSelected && (newPassword === '' || errorState['newPassword'] && errorState['newPassword'] !== '')) && <ErrorMessage error message={errorState['newPassword']} classKey={'font-normal text-left text-sm text-[#FC4523] mt-[8px]'} />}

                        {password.newPassword !== '' && <PassWordValidator newPassword={newPassword} />}
                        <div className="relative pt-[16px]">
                            <div className="flex justify-center">
                                <div className="relative w-full flex justify-center">
                                    <div className="relative w-[100%]">
                                        <input
                                            type={confirmType}
                                            className={`${submitSelected && (confirmPassword === '' || errorState['confirmPassword'] && errorState['confirmPassword'] !== '') ? 'input-error' : 'input-border'} peer m-0 block h-[58px] w-[100%] rounded-[4px] border border-solid border-[#ddd] bg-transparent bg-clip-padding px-3 pr-[47px] py-4 text-base font-minionpro font-normal outline-none text-black transition duration-200 ease-linear placeholder-[#1F1F1F] focus:border-[#ddd] focus:pb-[0.625rem] focus:pt-[1.625rem] focus:text-neutral-700 focus:outline-none peer-focus:text-black dark:border-[#ddd] dark:text-black dark:focus:border-black dark:peer-focus:text-black [&:not(:placeholder-shown)]:pb-[0.625rem] [&:not(:placeholder-shown)]:pt-[1.625rem]`}
                                            id="confirmPassword"
                                            data-testid='confirm_password'
                                            onFocus={() => {
                                                setsubmitSelected(false)
                                                setConfirmtype("text")
                                            }
                                            }
                                            placeholder=""
                                            onChange={(e) => handleInput('confirmPassword', e.target.value)}

                                        />

                                        <label
                                            className={`pointer-events-none absolute left-0 top-0 origin-[0_0] border border-solid border-transparent px-3 py-4 ${submitSelected && (confirmPassword === '' || errorState['confirmPassword'] && errorState['confirmPassword'] !== '') ? 'text-[#FC4523] ' : 'text-[#1F1F1F]'}font-minionpro transition-[opacity,_transform] duration-200 ease-linear peer-focus:-translate-y-2 peer-focus:translate-x-[0.15rem] peer-focus:scale-[0.85] peer-focus:text-black peer-[:not(:placeholder-shown)]:-translate-y-2 peer-[:not(:placeholder-shown)]:translate-x-[0.15rem] peer-[:not(:placeholder-shown)]:scale-[0.85] motion-reduce:transition-none dark:text-black dark:peer-focus:text-black`}
                                        >
                                            Confirm Password
                                        </label>
                                    </div>
                                </div>
                            </div>

                            {confirmType === "text" ? (
                                <img
                                    className="absolute top-[32px] right-[16px] cursor-pointer"
                                    src="/assets/images/eye-open.svg"
                                    id="newPasswordIcon"
                                    alt=""
                                    onClick={() => setConfirmtype("password")}
                                />
                            ) : (
                                <img
                                    className="absolute top-[32px] right-[16px] cursor-pointer"
                                    src={`/assets/images/${submitSelected && (confirmPassword === '' || errorState['confirmPassword'] && errorState['confirmPassword'] !== '') ? 'eye-error.svg' : 'eye.svg'}`}
                                    id="newPasswordIcon"
                                    alt=""
                                    onClick={() => setConfirmtype("text")}
                                />
                            )}
                            {submitSelected && !loading && (submitSelected && (confirmPassword === '' || errorState['confirmPassword'] && errorState['confirmPassword'] !== '')) && <ErrorMessage error message={errorState['confirmPassword']} classKey={'font-normal text-left text-sm text-[#FC4523] mt-[8px]'} />}

                            <br />
                        </div>
                        <Button
                            text="Set Password"
                            type="submit"
                            testId="reset-btn"
                            disabled={loading}
                            handleClick={handleSubmit}
                            loading={loading}
                            classKey={`w-[100%] relative ${checkState() ? 'bg-[#9E2064]' : 'bg-[#9E2064]'} bg-primary px-4 py-[16px] mt-4 mb-[52px] text-white rounded-[0.75rem] font-minionpro font-bold text-lg`}

                        />
                    </div>
                </div>
            </div>
        </CardHeader>
    );
}
